export { ErrorPage, ErrorPageProps } from './ErrorPage';



// WEBPACK FOOTER //
// ./components/ErrorPage/index.ts